
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.212 14.317l-.183-.183c0-.045-.091-.183-.137-.64-.046-.412.183-.915.183-.961l.046-.046c.045 0 .045 0 .045.046l.092.458 1.876-1.556-.092-.503-.045-.687L6.95 7.73H5.899l-1.83.457L.315 9.467H.271s-.046 0-.046-.045c0 0-.183-.55.412-.87a79.344 79.344 0 002.608-1.555c-.046-.046-.137-.183-.137-.55 0-.365.183-.411.274-.411.092 0 .183.046.183.046.046.045.092.183.092.411 0 .092 0 .183-.046.23l.778-.504c.045-.046 0-.229 0-.55 0-.365.183-.411.274-.411.092 0 .183.046.183.046.046.046.092.183.092.412 0 .091 0 .183-.046.228l.778-.549c-.046-.091-.092-.229-.092-.549 0-.366.183-.412.275-.412.091 0 .183.046.183.046.046.046.091.183.091.412 0 .091 0 .183-.045.229l.686-.504c0-.366-.183-3.248.412-3.843.091-.091.183-.137.274-.137.138 0 .229.046.32.137.595.64.458 3.477.412 3.843l.687.504c0-.046-.046-.138-.046-.229 0-.229.091-.366.091-.366a.35.35 0 01.23-.092c.09 0 .274.046.274.412 0 .32-.046.458-.092.55l.778.548c0-.045-.046-.137-.046-.228 0-.23.092-.366.092-.366a.35.35 0 01.229-.092c.091 0 .274.046.274.412 0 .32-.046.503-.091.549l.777.503c0-.046-.045-.137-.045-.229 0-.228.091-.366.091-.366a.35.35 0 01.229-.091c.091 0 .274.046.274.412s-.045.503-.137.549c.275.183 2.105 1.235 2.608 1.555.595.32.412.87.412.87s0 .045-.046.045h-.045l-3.707-1.235-1.83-.457H8.095l-.046 2.516-.046.686-.091.504 1.876 1.555.091-.457c0-.046.046-.046.046-.046s.046 0 .046.046.229.503.183.96c-.046.412-.137.595-.137.641l-.183.183h-.092l-.092-.091-2.104-1.053v.183c0 .046-.046.046-.046.046h-.229c-.046 0-.046-.046-.046-.046v-.183l-2.15 1.053.137.045z"}})])
          )
        }
      }
    